import { render } from "./ModalPromoCodeTargeting.vue?vue&type=template&id=5658ed3d&ts=true"
import script from "./ModalPromoCodeTargeting.vue?vue&type=script&lang=ts"
export * from "./ModalPromoCodeTargeting.vue?vue&type=script&lang=ts"

import "./ModalPromoCodeTargeting.vue?vue&type=style&index=0&id=5658ed3d&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__